import { TOUR_TRANSLATIONS } from "../translations"

export const getMarketplacesGeneralSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="mp-general-filters"]',
            title: t.mpGeneralFilters.title,
            content: t.mpGeneralFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="mp-general-numbers"]',
            title: t.mpGeneralNumbers.title,
            content: t.mpGeneralNumbers.content,
        },
        {
            target: '[data-tour="mp-general-market-position"]',
            title: t.mpGeneralMarketPosition.title,
            content: t.mpGeneralMarketPosition.content,
        },
        {
            target: '[data-tour="mp-general-market-details"]',
            title: t.mpGeneralMarketDetails.title,
            content: t.mpGeneralMarketDetails.content,
        },
        {
            target: '[data-tour="mp-general-authorized"]',
            title: t.mpGeneralAuthorized.title,
            content: t.mpGeneralAuthorized.content,
        },
        {
            target: '[data-tour="mp-general-top-sellers"]',
            title: t.mpGeneralTopSellers.title,
            content: t.mpGeneralTopSellers.content,
        },
    ]
}
